import Vue from 'vue'
import isEqual from 'lodash.isequal'

class Query {
    static getLocationQuery(address) {
        if (address?.id)
            return {
                address: address?.id,
                location:
                    address?.latitude && address?.longitude
                        ? `${address.latitude}|${address.longitude}`
                        : undefined,
            }
        if (address?.latitude && address.longitude)
            return {
                address: undefined,
                location: `${address.latitude}|${address.longitude}`,
            }
        return {
            address: undefined,
            location: undefined,
        }
    }
    static getLocationParams(address, onlyCoreApi = false) {
        if (address?.id)
            return {
                user_address: address.id,
                user_lat: undefined,
                user_lon: undefined,
                location: !onlyCoreApi
                    ? address.latitude
                        ? `${address.latitude}|${address.longitude}`
                        : undefined
                    : undefined,
            }
        if (address?.latitude && address.longitude)
            return {
                user_address: undefined,
                user_lat: address.latitude,
                user_lon: address.longitude,
                location: !onlyCoreApi ? `${address.latitude}|${address.longitude}` : undefined,
            }
        return {
            user_address: undefined,
            user_lat: undefined,
            user_lon: undefined,
            location: undefined,
        }
    }
    static getDeliveryTimeQuery(time) {
        return time
            ? {
                  delivery: Vue.moment(time).valueOf(),
              }
            : {
                  delivery: undefined,
              }
    }
    static getDeliveryTimeParams(time) {
        if (time) time = Vue.moment(time)
        return time
            ? {
                  pre_order_date: time
                      .clone()
                      .add(Vue.prototype.$deliveryPeriod, 'minutes')
                      .toISOString(),
                  deliverytime: time.valueOf(),
              }
            : {
                  pre_order_date: undefined,
                  deliverytime: undefined,
              }
    }
    static getCanteenParams(canteen) {
        return canteen
            ? {
                  cloudcanteen: canteen.isResidential ? undefined : canteen.id,
                  residentialcanteen: canteen.isResidential ? canteen.id : undefined,
              }
            : {
                  cloudcanteen: undefined,
                  residentialcanteen: undefined,
              }
    }
    static removeUnnecessaryQuery(params) {
        return Object.assign(params, {
            user_address: undefined,
            user_lat: undefined,
            user_lon: undefined,
            location: undefined,
            pre_order_date: undefined,
            deliverytime: undefined,
        })
    }

    // Basic query: location and order time query params
    static locationChanged(queryParams, queryParamsOld) {
        return (
            !isEqual(queryParams.user_address, queryParamsOld.user_address) ||
            !isEqual(queryParams.user_lat, queryParamsOld.user_lat) ||
            !isEqual(queryParams.user_lon, queryParamsOld.user_lon) ||
            !isEqual(queryParams.location, queryParamsOld.location)
        )
    }
}

export { Query }
